module.exports = __webpack_public_path__ + "assets/2bc2ae18b45791bf9c6eeac1bff73823.mp3";